import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import AddWorkOrderForm from "./AddWorkOrderForm";
import {
  useGetOrderLineItemDetails,
  usePostWorkOrderBatchesForLine,
} from "../../hooks";

export const AddWorkOrderContent = ({ lineId }) => {
  const { data, isLoading } = useGetOrderLineItemDetails(lineId);
  const { mutate: createBatches, isSuccess } = usePostWorkOrderBatchesForLine();

  useEffect(() => {
    isSuccess && window.location.reload();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const isRepeat = formData.isRepeat;
    const addTesting = formData.addTesting;
    const testing = formData?.testing
      ?.map((t) => ({
        testId: t.testId,
        quantity: Number(t.quantity),
      }))
      .filter((t) => t.quantity);
    const includeTesting = addTesting && !!testing?.length;

    const payload = {
      lineId,
      quantity: Number(formData.quantity),
      estimatedCompleted: Number(formData.estimatedCompleted),
      batches: Number(formData.batches),
      repeatStartDate: dayjs(formData.repeatStartDate).toISOString(),
      isRepeat,
      ...(isRepeat && {
        repeatOption: Number(formData.repeatOption),
        repeatWeekdays: formData?.repeatWeekdays,
        repeatEveryIteration: formData?.repeatEveryIteration,
        repeatEvery: formData.repeatEvery,
      }),
      ...(includeTesting && { testing }),
    };
    createBatches(payload);
  };

  const partsPerTree = data?.partsPerTree[`${data.locationId}`];

  const defaultValues = {
    trees: 1,
    quantity: partsPerTree,
    estimatedCompleted: partsPerTree,
    batches: 1,
    repeatStartDate: dayjs().toISOString(),
    isRepeat: false,
    customerDueDate: data?.dueDate,
  };

  return (
    <HubDialogContent>
      <HubHookFormWrapper defaultValues={defaultValues} onSubmit={onSubmit}>
        <Stack gap="25px">
          <Stack alignItems="start">
            <Typography variant="h6">
              <strong>{data?.lineNumber}</strong> : Add Work Orders
            </Typography>
            <Stack>
              <Typography variant="caption" noWrap>
                Add Work Orders to Existing Purchase Order Line Items for:
              </Typography>
              <Typography variant="boldCaptionMain" noWrap>
                {data?.partName}
              </Typography>
            </Stack>
          </Stack>

          <AddWorkOrderForm
            totalDays={data?.totalDays[`${data.locationId}`]}
            partsPerTree={partsPerTree}
            customerDueDate={data?.dueDate}
            orderQuantity={data?.quantity}
          />
          <HubCancelSubmitGroup
            disabled={isLoading || !data?.id}
            isLoading={isLoading}
            label="Create Work Orders"
            // disableOnInvalid
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default AddWorkOrderContent;
